const successDialog = require("./successDialog");
const appendToBody = require("../dom/appendToBody");
const showDialog = require("../dom/showDialog");
const hideDialog = require("../dom/hideDialog");
const removeElement = require("../dom/removeElement");

/**
 * @param message {string}
 * @return {void}
 */
module.exports = function showSuccessDialogToast(message) {
    const successDialog$ = successDialog(message);
    appendToBody(successDialog$);

    showDialog(successDialog$);

    window.setTimeout(() => {
        hideDialog(successDialog$);
        removeElement(successDialog$);
    }, 2000);
}
